// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-26ca05e4","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/private/CampaignsSettings.vue
// module id = 262
// module chunks = 0